var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAverageRate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "1183 221 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.25 19 28.501",
    fill: "#333",
    x: 1220,
    y: 221,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 29,
    viewBox: "0.494 0.484 18.506 27.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M9.747.484C4.645.484.494 4.634.494 9.736c0 4.426 6.556 13.383 8.093 15.421 0 .659 0 1.305-.016 1.899a1.157 1.157 0 0 0 1.126 1.187h.032c.623 0 1.138-.498 1.155-1.126.016-.61.016-1.274.016-1.951 1.526-2.025 8.1-11 8.1-15.43C19 4.634 14.849.484 9.747.484zm0 22.352c-2.543-3.498-6.94-10.155-6.94-13.1a6.947 6.947 0 0 1 6.94-6.94 6.947 6.947 0 0 1 6.939 6.94c0 2.945-4.397 9.602-6.94 13.1z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    fill: "#333",
    opacity: 0.451,
    x: 1227,
    y: 228,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 6,
    height: 6,
    viewBox: "0.433 0.423 4.626 4.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M2.747.423A2.317 2.317 0 0 0 .433 2.736 2.317 2.317 0 0 0 2.747 5.05 2.316 2.316 0 0 0 5.06 2.736 2.316 2.316 0 0 0 2.747.423z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    fill: "#333",
    opacity: 0.451,
    x: 1190,
    y: 246,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0.423 0.929 13.879 13.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M7.362.929a6.947 6.947 0 0 0-6.94 6.94 6.947 6.947 0 0 0 6.94 6.939 6.947 6.947 0 0 0 6.94-6.94 6.947 6.947 0 0 0-6.94-6.94zm0 11.565a4.63 4.63 0 0 1-4.626-4.626 4.63 4.63 0 0 1 4.626-4.626 4.63 4.63 0 0 1 4.626 4.626 4.63 4.63 0 0 1-4.626 4.626z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 7,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.222 0 4.555 7",
    fill: "#333",
    opacity: 0.451,
    x: 1211,
    y: 263,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 7,
    viewBox: "0.174 0.089 4.446 6.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M3.882.168A1.155 1.155 0 0 0 2.385.83C1.867 2.17 1.218 3.731.344 5.162a1.158 1.158 0 0 0 1.975 1.206C3.288 4.78 3.987 3.1 4.543 1.665a1.16 1.16 0 0 0-.66-1.497z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.375 0 7.25 5",
    fill: "#333",
    opacity: 0.451,
    x: 1203,
    y: 271,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8,
    height: 5,
    viewBox: "0.533 0.358 6.702 4.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M5.36.609c-1.159.918-2.475 1.61-4.028 2.114a1.157 1.157 0 0 0 .716 2.2c1.793-.582 3.39-1.424 4.748-2.5A1.157 1.157 0 1 0 5.36.609z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 7,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.143 6 6.714",
    fill: "#333",
    opacity: 0.451,
    x: 1215,
    y: 254,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 6,
    height: 7,
    viewBox: "0.17 0.666 5.444 6.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M3.886.818C1.976 1.901.916 3.782.284 5.101a1.155 1.155 0 1 0 2.085 1c.803-1.674 1.622-2.683 2.66-3.273A1.156 1.156 0 1 0 3.886.818z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0 0.716 7 4.569",
    fill: "#333",
    opacity: 0.451,
    x: 1223,
    y: 251,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7,
    height: 6,
    viewBox: "0.141 0.757 6.685 4.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M6.317.955a1.16 1.16 0 0 0-1.606.31c-.38.562-1.16 1.335-3.517 1.547a1.157 1.157 0 0 0 .208 2.304c2.504-.225 4.213-1.06 5.225-2.555a1.157 1.157 0 0 0-.31-1.606z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    viewBox: "0.25 0 28.5 38",
    fill: "#333",
    x: 1183,
    y: 239,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 38,
    viewBox: "0.483 0.989 27.758 37.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M17.103 35.702c3.65-3.892 11.138-12.845 11.138-20.834C28.241 7.086 22.144.99 14.361.99 6.582.99.484 7.086.484 14.87c0 10.328 12.551 22.31 13.086 22.815.222.21.507.316.793.316.843 0 1.643-.03 2.402-.087a1.156 1.156 0 0 0 1.067-1.24 1.134 1.134 0 0 0-.728-.971zm-2.741-.49C11.63 32.425 2.796 22.797 2.796 14.868c0-6.485 5.08-11.566 11.566-11.566 6.486 0 11.566 5.08 11.566 11.566 0 7.93-8.834 17.557-11.566 20.344z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageRate);
export default __webpack_public_path__ + "static/media/average-rate.b7fd980d6d2f084beec6ace3c6077fa7.svg";
export { ForwardRef as ReactComponent };